import { useTranslation } from 'next-i18next';
export const useTravellersLabelMultiroom = value => {
  const {
    t
  } = useTranslation(['searchForm']);
  const roomCount = value?.rooms.length;
  if (!value || !roomCount || !value.adultsCount) {
    return '';
  }
  if (roomCount <= 1 && !value.childrenCount) {
    return t('travellersFieldMultiroom.adultsLabel', {
      count: value.adultsCount
    });
  }
  const adultsLabelShort = t('travellersFieldMultiroom.adultsLabelShort', {
    count: value.adultsCount
  });
  const childrenLabel = t('travellersFieldMultiroom.childrenLabel', {
    count: value.childrenCount
  });
  if (roomCount <= 1) {
    return `${adultsLabelShort}, ${childrenLabel}`;
  }
  const roomLabel = t('travellersFieldMultiroom.roomLabel', {
    count: roomCount
  });
  if (!value.childrenCount) {
    return `${adultsLabelShort}, ${roomLabel}`;
  }
  return `${adultsLabelShort}, ${childrenLabel}, ${roomLabel}`;
};